import React, { useState } from "react";
import servicosMotivo from "../../servicos/servicos-motivo";
import MenuLateral from "./MenuLateral";
import NavMenu from "./Nav";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { ToastContainer, toast } from 'react-toastify';
import Salvar from "../../img/svgs/Salvar";

const dadosMotivo = {
    "descricao": "",
    "qtd_milhas": 0
}

const CadastroMotivo = () => {
    const [data, setData] = useState(dadosMotivo);
    const { register, handleSubmit, formState: { errors } } = useForm();


    const handleChange = (e) => {
        let { name, value } = e.target;
        if (name === 'qtd_milhas') {
            value = Number(value);
        }
        if(name === 'descricao'){
            value = String(value).toUpperCase();
        }
        setData({ ...data, [name]: value });
    }

    const clearData = () => {
        const descricao = document.querySelector('#descricao');
        const qtd_milhas = document.querySelector('#qtd_milhas');
        descricao.value = '';
        qtd_milhas.value = '';
    }

    const criarMotivo = () => {
        servicosMotivo.create(data)
            .then(response => {
                if (response.status === 201) {
                    toast.success("Motivo cadastrado com sucesso!", {
                        theme: "colored",
                    });
                    clearData();
                }
            })
            .catch(e => {
                toast.error("Não foi possível cadastrar o Motivo!", {
                    theme: "colored"
                });
                console.log(e);
            })

    }
    return <>
        <NavMenu />
        <ToastContainer />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="w-75 mt-4">
                <form className="cadastros" onSubmit={handleSubmit(criarMotivo)}>
                    <Form.Group className="mb-3" controlId="descricao">
                        <Form.Label className="label-texto">Descricão</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="text"
                            name="descricao"
                            {...register("descricao", { required: true, minLength: 2 })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.descricao && <p className="errosValidacao">Requerido mínimo 2 letras</p>}

                    <Form.Group className="mb-3" controlId="qtd_milhas">
                        <Form.Label className="label-texto">Quantidade de Milhas</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="number"
                            name="qtd_milhas"
                            {...register("qtd_milhas", { required: true })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.qtd_milhas && <p className="errosValidacao">Requerido</p>}

                    <button type="submit" className="btn-icones rounded p-1"><Salvar /> Salvar</button>
                </form>

            </div>
        </div>
    </>
}

export default CadastroMotivo;